import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
// import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import OfferMappingForm from "../../components/offer-mapping/OfferMappingForm";
import { fetchPlanOffersData } from "../../redux/plans-reducers/plansSlice";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../components/common-data/Converts";
import Loader from "../../components/ui/Loader";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { toast } from "react-toastify";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { offer_mapping_DEL } from "../../data/ApiEndpoints";
import { CheckCircleIcon, XCircleIcon } from "../../images/icons/icons";

const OfferMapping = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { plansData, plansLoading } = useSelector((state) => state.plans);
  const { loading } = useSelector((state) => state.delApi);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  //   const iniAllFilter = {};
  //   const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    status: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getAllOffers(filters) {
    dispatch(
      fetchPlanOffersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: offer_mapping_DEL,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getAllOffers(filters);
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    getAllOffers(filters);
  }, [filters]);

  useEffect(() => {
    if (plansData?.status && plansData?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: plansData.data,
        pagination:
          plansData?.pagination?.length > 0 ? plansData.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [plansData]);

  const tbColumns = [
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_custom",
      text: "custom max selling price",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_custom ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "max_price",
      text: "max selling price",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.max_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "offer_value",
      text: "offer amount (flat)",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.offer_value || 0)}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const isActive = row?.status === "active";
        return (
          <div className="tb-data" style={{ textAlign: "center" }}>
            <span
              className={`badge text-capitalize fs-6 ${
                isActive ? "bg-success" : "bg-danger"
              }`}>
              {row?.status}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "update_plan_offer",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16">
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}>
            {loading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16">
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: Offer Mapping Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Details Modal"
          ariaHideApp={false}>
          {/* <div className="createNewCTOModalContainer"> */}
          {/* <ModalHeadAndClose
              title={modValues.modName?.replace(/_/g, " ")}
              onClose={onCloseModal}
            /> */}

          <OfferMappingForm
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={() => getAllOffers(filters)}
            isEdit={modValues.modName === "update_plan_offer"}
            rowData={modValues.rowData}
          />
          {/* </div> */}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Offer Mapping"}
              createBtnTxt={"+ Map New Offer"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "map_new_offer",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
              {plansLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.allData}
                  tableColumns={tbColumns}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  isFirstColSticky={true}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default OfferMapping;
